import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { MMPlayerBlockAttsInterface } from '~/types/AppData/Blocks/MMPlayerBlockInterface';
import VideoPlayerEmbed from '~/components/Shared/Video/VideoPlayerEmbed';

export default component$((value: MMPlayerBlockAttsInterface): JSX.Element => {
  if (!value.html) {
    return <></>;
  }

  return <VideoPlayerEmbed html={value.html} version={value.version} />;
});
